<!-- Watermark Position Select Button Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <p-selectButton id="{{ name }}"
      ariaLabelledBy="{{ name }}_label"
      formControlName="{{ name }}"
      [disableControl]="disabled"
      [options]="FlatModels.MediaEntityModels.CopyrightPositionArray"
      optionLabel="name"
      optionValue="value"
      [ngClass]="{
        'ng-invalid': control.invalid && control.touched,
        'ng-dirty': control.invalid && control.touched
      }"
      (onChange)="valueChange.emit($event)">
      <ng-template let-item pTemplate>
        <div class="p-1">
          <i [class]="FlatModels.MediaEntityModels.CopyrightPositionIcon[item.value]"></i>
        </div>
      </ng-template>
    </p-selectButton>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}